import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/api";

const AutenticacaoContexto = createContext(null);

export function ProvedorAutenticacao({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [tentativasFalhas, setTentativasFalhas] = useState(0);

  const carregarMe = useCallback(async () => {
    const token = localStorage.getItem("bolao_token");
    if (!token) {
      setUsuario(null);
      setCarregando(false);
      setTentativasFalhas(0);
      return;
    }
    
    try {
      const { data } = await api.get("/auth/me");
      setUsuario(data);
      setTentativasFalhas(0);
    } catch (error) {
      // Erro 401: Token inválido/expirado - fazer logout
      if (error?.response?.status === 401) {
        localStorage.removeItem("bolao_token");
        setUsuario(null);
        setTentativasFalhas(0);
      } else {
        // Outros erros (CORS, rede, etc): manter sessão ativa
        // Se já temos um usuário, mantém ele
        // Se não temos, incrementa tentativas mas não faz logout
        setTentativasFalhas(prev => prev + 1);
        console.warn(`Erro ao carregar usuário:`, error?.message);
      }
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    carregarMe();
    
    // Retry automático a cada 5 segundos se houver erro temporário
    // Mas para após 10 tentativas falhas para evitar spam
    const intervalo = setInterval(() => {
      const token = localStorage.getItem("bolao_token");
      if (token && tentativasFalhas > 0 && tentativasFalhas < 10) {
        carregarMe();
      }
    }, 5000);
    
    return () => clearInterval(intervalo);
  }, [carregarMe, tentativasFalhas]);

  const login = async (email, senha) => {
    const { data } = await api.post("/auth/login", { email, senha });
    localStorage.setItem("bolao_token", data.token);
    setUsuario(data.usuario);
    return data.usuario;
  };

  const cadastrar = async (dados) => {
    const { data } = await api.post("/auth/cadastro-apostador", dados);
    localStorage.setItem("bolao_token", data.token);
    setUsuario(data.usuario);
    return data.usuario;
  };

  const sair = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("bolao_token");
    setUsuario(null);
  };

  const aceitarRegulamento = async (versao) => {
    const { data } = await api.post("/auth/aceitar-regulamento", { versao });
    setUsuario(data);
    return data;
  };

  return (
    <AutenticacaoContexto.Provider
      value={{ usuario, carregando, login, cadastrar, sair, aceitarRegulamento, recarregar: carregarMe }}
    >
      {children}
    </AutenticacaoContexto.Provider>
  );
}

export function useAutenticacao() {
  const ctx = useContext(AutenticacaoContexto);
  if (!ctx) throw new Error("useAutenticacao fora do provedor");
  return ctx;
}

export { AutenticacaoContexto };
